import { store } from '../store';
import { setAuth, clearAuth, logout } from '../views/slice/role';

export const loginUser = (user, token) => {
  // Set Redux state
  store.dispatch(setAuth({ user, token }));

  // Set localStorage
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('token', token); // Store token as string, not JSON
};

export const logoutUser = () => {
  // Clear Redux state
  store.dispatch(clearAuth());

  // Clear localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  // Redirect to login
  window.location.href = '/login';
};

export const getStoredUser = () => {
  try {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error('Error parsing stored user:', error);
    return null;
  }
};

export const getStoredToken = () => {
  try {
    const tokenStr = localStorage.getItem('token');
    // Try to parse as JSON first (for backward compatibility)
    return tokenStr ? JSON.parse(tokenStr) : null;
  } catch (error) {
    // If JSON.parse fails, return the raw string
    const tokenStr = localStorage.getItem('token');
    return tokenStr || null;
  }
};
